const starts = '2026-03-04T16:00:00-07:00'
const conferenceConfig = {
  // NOTE: we have turned on the conference at 4:00 PM MST the Wednesday before for APAC.
  starts,
  // NOTE: the conference generally ends at 6:00 PM MST on Saturday but stays up for Japan until 7:00 AM MST on Sunday.
  ends: '2026-03-07T18:00:00-07:00',
  preview: {
    redirects: {
      on: 'https://www.familysearch.org/en/labs/on/SFKY5GXKYPVHF0QZM04GV',
      off: 'https://www.familysearch.org/en/labs/off/SFKY5GXKYPVHF0QZM04GV',
    },
  },
  resources: {
    downloadable: {
      // Syllabi are available a week before the conference opens.
      syllabi: '2026-02-26T09:00:00-07:00',
      // Available when the conference starts at the presenters discretion.
      slides: starts,
    },
  },
}

export default conferenceConfig
